var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyAsSet = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 19.976v5.109c0 .777.093 1.52.59 2.116.527.612 1.287.876 2.062.876h6.374c.73 0 1.551-.248 2.048-.86.496-.595.573-1.372.573-2.149v-5.092c0-1.901-.806-2.976-2.636-2.976H8.652C6.806 17.017 6 18.058 6 19.976Zm3.148 6.3c-1.086 0-1.458-.497-1.458-1.621V23.43h3.273v2.844H9.148Zm5.398 0c.404 0 .807-.1 1.101-.414.31-.33.31-.76.31-1.207V23.43H12.67v2.844h1.876Zm.047-7.474c1.054 0 1.365.546 1.365 1.604v1.223H12.67v-2.827h1.923Zm-3.615 2.827v-2.827h-1.83c-1.07 0-1.458.48-1.458 1.604v1.223h3.288ZM6 6.976v5.109c0 .777.093 1.52.59 2.116.527.612 1.287.876 2.062.876h6.374c.73 0 1.551-.248 2.048-.86.496-.595.573-1.372.573-2.149V6.976c0-1.901-.806-2.976-2.636-2.976H8.652C6.806 4.017 6 5.058 6 6.976Zm3.148 6.3c-1.086 0-1.458-.497-1.458-1.621v-1.223h3.273v2.843H9.148Zm5.398 0c.404 0 .807-.1 1.101-.414.31-.33.31-.76.31-1.207v-1.223H12.67v2.843h1.876Zm.047-7.474c1.054 0 1.365.546 1.365 1.604v1.223H12.67V5.802h1.923ZM10.978 8.63V5.802h-1.83c-1.07 0-1.458.48-1.458 1.604v1.223h3.288Z",
  fill: "#231F20"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 26.923s1.155-.01 1.985-.548c2.977-1.934-.124-6.922-.124-8.418 0-1.096.124-1.996 3.1-1.996M22 5s1.155.01 1.985.548c2.977 1.933-.124 6.922-.124 8.418 0 1.096.124 1.995 3.1 1.995",
  stroke: "#000",
  strokeWidth: 1.7
})));
export default SvgBuyAsSet;